/**
 * Represents all sense types
 */
var SenseType;
(function (SenseType) {
    SenseType["TempSense"] = "tempSense";
    SenseType["HumiditySense"] = "humiditySense";
    SenseType["ShockSense"] = "shockSense";
    SenseType["FreezeSense"] = "freezeSense";
})(SenseType || (SenseType = {}));
/**
 * Represents all possible unit types
 */
var ValueType;
(function (ValueType) {
    ValueType["Temperature"] = "temperature";
    ValueType["Humidity"] = "humidity";
})(ValueType || (ValueType = {}));
/**
 * Represents undefined batteryStatus value
 */
var BatteryStatus;
(function (BatteryStatus) {
    BatteryStatus["Undefined"] = "ff";
})(BatteryStatus || (BatteryStatus = {}));
export { SenseType, ValueType, BatteryStatus };
